import React from 'react';
import classNames from 'classnames';
import { CollapsibleSection } from 'components/CollapsibleSection';
import Counter from 'components/Counter';
import { COLOR_VARIANT } from 'models/Colors';

import './EnterpriseSuggestedActionsSection.styles.scss';

type EnterpriseSuggestedActionsSectionProps = {
  className?: string;
  title: string;
  count: number;
  defaultOpen?: boolean;
};

const EnterpriseSuggestedActionsSection: React.FC<
  EnterpriseSuggestedActionsSectionProps
> = (props) => {
  const { children, className, title, count, defaultOpen = !!count } = props;

  const classes = classNames('enterprise-suggested-actions-section', className);

  return (
    <CollapsibleSection
      defaultOpen={defaultOpen}
      className={classes}
      trigger={
        <div className="enterprise-suggested-actions-section__title">
          <p>{title}</p>
          <Counter
            count={count}
            variant={COLOR_VARIANT.GREY}
            displayEmptyValue
          />
        </div>
      }
    >
      {children}
    </CollapsibleSection>
  );
};

export default EnterpriseSuggestedActionsSection;
